import { useResource } from "../../../Hooks/UseResource";

export default function ESignAndTermsAndConditionsResource() {
  const [resourceError, loading, getData, postData, uploadData] = useResource();

  const requestEsign = (kycSessionToken,holderType,termsAndConditions) => {
    return postData({
      url: "/public/esign-request",
      data: { appKey: kycSessionToken,holderType:holderType,isTermsAndConsitionsAccepted:termsAndConditions},
    });
  };

  const eSignedKycApplication =(kycSessionToken) =>{
    return postData({
      url:"/public/e-signed-kyc-application",
      data: { appKey: kycSessionToken },
    })
  }

  const getESignTermsAndConditions =() =>{
    return postData({
      url:"/public/e-sign-terms-conditions"
    })
  }

  return [requestEsign,eSignedKycApplication,getESignTermsAndConditions];
}
